import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const
  animations = {
    enquire: async () => await import('./../animations/enquire'),
    revealTextByLine: () => import('./../animations/reveal-text-by-line'),
  },
  helpers = {
    updateSmoothScroll: () => import('./../helpers/smooth-scroll-update'),
    smoothScrollTo: () => import('./../helpers/smooth-scroll-to')
  };

const
  toRevealTexts = document.querySelectorAll('.text-by-line'),
  container = document.querySelector('.section-horizontal'),
  elements = document.querySelectorAll('.serie-selection-yacht'),
  menu = document.querySelectorAll('.menu-bottom'),
  menu1 = document.querySelectorAll('.menu-bottom1')

export const serieController = () => {

  animations.enquire().then(module => module.enquire())
  const series_length = $(".serie-selection-yacht").length;
  
  animations.revealTextByLine().then(module => {
    for (const text of toRevealTexts) {
      module.revealTextByLine(text)
    }
  })

  ScrollTrigger.create({
    scroller: '.smooth-scroll',
    trigger: "#horizontal-section",
    start: 'top top',
    end: 'top bottom',
    once: false,
    onEnter: (event) => {
      gsap.to($(".menu-bottom1"), {
        y: "0",
        duration: .7
      })
    },
    onLeaveBack: (event) => {
      gsap.to($(".menu-bottom1"), {
        y: "100%",
        duration: .7
      })
    }
  })

  let toggle = true;

  ScrollTrigger.create({
    scroller: '.smooth-scroll',
    trigger: ".enquire",
    start: 'top bottom-=46',
    end: '+=400%',
    onToggle: (event) => {
      toggle = !toggle;
      gsap.to($(".menu-bottom1"), {
        y: toggle ? "0" : "100%",
        duration: .7
      })
    }
  })

  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function () {
      let horizontalScroll = gsap.to(container, {
        x: () => -(container.scrollWidth - document.documentElement.clientWidth) + "px",
        ease: "none",
        scrollTrigger: {
          scroller: '.smooth-scroll',
          trigger: container,
          pin: true,
          scrub: true,
          invalidateOnRefresh: true,
          fastScrollEnd: false,
          end: () => "+=" + (document.documentElement.clientWidth * series_length - 100 * series_length + 50 - 50 * (series_length - 1))
        }
      })

      //TRACKING GTM :_D
      horizontalScroll.eventCallback("onStart",function(){ document.dispatchEvent(new CustomEvent('scrollDirection', {detail: {direction : 'scroll_orizzontale'}})); });
      horizontalScroll.eventCallback("onComplete",function(){ document.dispatchEvent(new CustomEvent('scrollDirection', {detail: {direction : 'scroll_verticale'}})); });

      let horizontalScroll1 = gsap.to(menu, {
        x: () => (container.scrollWidth - document.documentElement.clientWidth) + "px",
        ease: "none",
        scrollTrigger: {
          scroller: '.smooth-scroll',
          trigger: container,
          pin: true,
          scrub: true,
          invalidateOnRefresh: true,
          fastScrollEnd: false,
          end: () => "+=" + (document.documentElement.clientWidth * series_length - 100 * series_length + 50 - 50 * (series_length - 1)),
          onUpdate: (event) => {
            if(event.progress < 0.01) {
              $(".anchor-horizontal").removeClass("active-a");
              $(".anchor-horizontal:first-of-type").addClass("active-a");
            }
          },
        }
      })

      for (const element of elements) {
        ScrollTrigger.create({
          scroller: '.smooth-scroll',
          trigger: element,
          containerAnimation: horizontalScroll,
          start: 'left center',
          end: 'center center',
          onUpdate: (event) => {
            $(".anchor-horizontal").removeClass("active-a");
            $(".anchor-horizontal[data-id='" + element.getAttribute("data-id") + "']").addClass("active-a");
          },
          onEnter: (event) => {
            gsap.to(element.querySelectorAll('.elem1'), {
              opacity: 1,
              marginTop: 0,
              duration: .7
            })
            gsap.to(element.querySelectorAll('.elem2'), {
              opacity: 1,
              delay: 0.1,
              duration: .7
            })
            gsap.to(element.querySelectorAll('.btn-hidden'), {
              clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
              duration: .7,
              delay: 0.45
            })
            gsap.to(element.querySelectorAll('.title-opacity'), {
              opacity: 1,
              duration: .7,
              delay: 0.35,
              stagger: .2,
            })
            gsap.to(element.querySelectorAll('.hr-show'), {
              width: '100%',
              duration: 0.9,
              delay: 0.35,
              stagger: .2,
            })
          }
        })
      }

      document.querySelectorAll(".anchor-horizontal").forEach(anchor => {
        anchor.addEventListener("click", function (e) {
          e.preventDefault();
          let targetElem = document.querySelector(e.target.getAttribute("href")),
            y = targetElem;
          let totalScroll = horizontalScroll.scrollTrigger.end - horizontalScroll.scrollTrigger.start,
            totalMovement = (elements.length - 1) * (targetElem.offsetWidth - 50) + 100;
          y = Math.round(horizontalScroll.scrollTrigger.start - 50 + (targetElem.offsetLeft / totalMovement) * totalScroll);

          helpers.smoothScrollTo().then(module => module.smoothScrollTo(y, 500, 0));
        });
      });

      ScrollTrigger.refresh(true)
      helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
    }
  })

}
